import { render } from "./LeadClientHeader.vue?vue&type=template&id=997c07e0"
import script from "./LeadClientHeader.vue?vue&type=script&lang=js"
export * from "./LeadClientHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__